import { API_URL } from "../constants";
import * as httpNetworking from "../httpNetworking";
import { GetSupportedPluginsResponse_Plugin } from "./plugins";

const URL = API_URL + "/techstack";
const VERSION = 0;

export type TechStackInfoResponse = {
    cores: string[];
    coreToDriver: { [key: string]: { id: string; displayName: string }[] };
    coreToPlugin: { [key: string]: GetSupportedPluginsResponse_Plugin[] };
    drivers: { id: string; displayName: string }[];
    plugins: GetSupportedPluginsResponse_Plugin[];
};

export async function getTechStackInfo(planType: "FREE" | "COMMERCIAL"): Promise<TechStackInfoResponse> {
    let options: httpNetworking.GETRequestConfig = {
        timeout: 10000,
        params: {
            planType
        }
    };

    let result = (await httpNetworking.simpleGETRequest(URL, options, VERSION)).data;
    return result;
}
